import { FC } from "react";
import "./reviewFooter.css";
import scorzaWordmark from "../../assets/images/scorza-wordmark-white.svg";

import { AppStoreLogo, PlayStoreLogo } from "../StoreLogo";

export const ReviewFooter: FC<{}> = () => {
    return (
        <div className="story-footer">
            <AppStoreLogo />
            <RefsixLogo />
            <PlayStoreLogo />
        </div>
    );
};
export const RefsixLogo: FC = () => {
    return <img className="footer-logo" src={scorzaWordmark}></img>;
};
